module.exports = __webpack_public_path__ + "media/images/tile-wide2-c8d73f22c86019bf53de03d082deaee2.png";